import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CarouselImageModel } from '../../models/carousel-image';
import { CarouselImageAdapter } from '../../adapters/carousel-image';
import { ApiBaseService } from '../../../../core/services/api/api-base.service';

/**
 * Serviço para gerenciar imagens do carrossel do hero
 * Endpoint: /administration/content/images
 */
@Injectable({
  providedIn: 'root',
})
export class CarouselImageApiService extends ApiBaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * Buscar todas as imagens ativas do carrossel
   * @returns Observable com array de imagens ordenadas por 'order'
   */
  getActiveImages(): Observable<CarouselImageModel[]> {
    const url = `${this.apiBaseUrl}/administration/content/images`;

    return this.http
      .get<any>(url)
      .pipe(map((response) => CarouselImageAdapter.fromApiArray(response)));
  }
}
